export default "__VITE_ASSET__BbzSb__3__"